import Button from 'components/base/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faKey, faNoteSticky, faUser } from '@fortawesome/free-solid-svg-icons';
import { Form } from 'react-bootstrap';
import axios from 'axios';
import { toast } from 'react-toastify';
import * as formik from 'formik';
import * as yup from 'yup';
const QueryForm = () => {
  const { Formik } = formik;
  const schema = yup.object().shape({
    email: yup.string().email('Invalid email!').required('Email is required!'),
    subject: yup
      .string()
      .min(4, 'Subject is Too Short')
      .max(30, 'Subject is Too Long')
      .required('Subject is required'),
    body: yup
      .string()
      .min(20, 'Message body is Too Short')
      .max(300, 'Message body is Too Long')
      .required('Message body is required')
  });

  const onSubmit = (values: any) => {
    axios
      .post(`${process.env.REACT_APP_ENDPOINT}/send-contactus-mail`, {
        email: values.email,
        subject: values.subject,
        message: values.body
      })
      .then(response => {
        if (response.data.status) {
          toast.success(
            "Your query has been submitted successfully. We'll get back to you soon."
          );
        } else {
          toast.error('Failed to submit your query. Please try again later.');
        }
      })
      .catch(error => {
        toast.error(
          'An error occurred while submitting your query. Please try again later.'
        );
      });
  };

  return (
    <>
      <p className="mb-5">
        If you have any query or suggestion, we are open to learn from you.
        Let's talk, reach us anytime.
      </p>
      <div className="col-12">
        <Formik
          validationSchema={schema}
          onSubmit={values => onSubmit(values)}
          initialValues={{
            email: '',
            subject: '',
            body: ''
          }}
        >
          {({ handleSubmit, handleChange, values, touched, errors }) => (
            <Form noValidate onSubmit={handleSubmit}>
              <Form.Group className="mb-3 text-start">
                <Form.Label htmlFor="email">Email address</Form.Label>
                <div className="form-icon-container">
                  <Form.Control
                    id="email"
                    type="email"
                    name="email"
                    className="form-icon-input"
                    placeholder="name@example.com"
                    value={values.email}
                    onChange={handleChange}
                    isValid={touched.email && !errors.email}
                    isInvalid={touched.email && !!errors.email}
                  />
                  <FontAwesomeIcon
                    icon={faUser}
                    className="text-body fs-9 form-icon"
                  />
                  <Form.Control.Feedback type="invalid">
                    {' '}
                    {errors.email}{' '}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>

              <Form.Group className="mb-3 text-start">
                <Form.Label htmlFor="subject">Subject</Form.Label>
                <div className="form-icon-container">
                  <Form.Control
                    id="subject"
                    type="text"
                    name="subject"
                    className="form-icon-input"
                    placeholder="subject"
                    value={values.subject}
                    onChange={handleChange}
                    isValid={touched.subject && !errors.subject}
                    isInvalid={touched.subject && !!errors.subject}
                  />
                  <FontAwesomeIcon
                    icon={faNoteSticky}
                    className="text-body fs-9 form-icon"
                  />
                  <Form.Control.Feedback type="invalid">
                    {' '}
                    {errors.subject}{' '}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>

              <Form.Group className="mb-2">
                <Form.Label>Message body</Form.Label>
                <div className="form-icon-container">
                  <Form.Control
                    as="textarea"
                    name="body"
                    value={values.body}
                    onChange={handleChange}
                    rows={4}
                    isValid={touched.body && !errors.body}
                    isInvalid={touched.body && !!errors.body}
                  />
                  <Form.Control.Feedback type="invalid">
                    {' '}
                    {errors.body}{' '}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>

              <Button type="submit" variant="primary" className="w-100 mb-3">
                Submit
              </Button>
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
};

export default QueryForm;
